import React from "react";
import styled from "styled-components";
import _ from "lodash";

const StyledDiv = styled.div`
  font-size:17px;
  color:#333;
  white-space: pre-wrap;
  word-break: break-word;
`;
const ViewOnlyDiv = ({ children, placeholder, style }) => {
  if (!placeholder) {
    placeholder = "--";
  }
  if (!children) {
    return <StyledDiv style={style}>{placeholder}</StyledDiv>;
  }

  return <StyledDiv style={style}>{children}</StyledDiv>;
};

export default ViewOnlyDiv;
